/* eslint-disable react/sort-comp, no-console */
import { node, object, bool } from 'prop-types';
import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import { Box, Stack, Button, Text } from 'chaser-components';
import { withRouter } from 'react-router';
import style from './ErrorBoundary.module.scss';

class ErrorBoundary extends Component {
  static propTypes = {
    children: node.isRequired,
    history: object.isRequired,
    center: bool,
  };

  static defaultProps = {
    center: false,
  };

  state = {
    error: null,
    eventId: null,
    feedbackModalOpen: false,
  };

  static getDerivedStateFromError(error) {
    if (error instanceof Error) {
      return { error };
    }

    return null;
  }

  componentDidCatch(err, info) {
    if (err.log === false) return;
    Sentry.withScope(scope => {
      if (err.info) scope.setExtras(err.info);
      scope.setLevel(Sentry.Severity.Fatal);
      scope.setExtras(info);
    });
  }

  componentDidMount() {
    this.retry();
    this.unlisten = this.props.history.listen(() => {
      if (this.state.error) {
        this.setState({ error: null });
      }
    });
    window.addEventListener('online', this.retry);
  }

  componentWillUnmount() {
    this.unlisten();
    window.removeEventListener('online', this.retry);
  }

  retry = () => {
    const { error } = this.state;
    if (error) {
      if (error.retry) {
        error.retry();
      }
    }
  };

  renderError() {
    const { error } = this.state;
    const { history } = this.props;
    let button = <Button onClick={() => history.push('/')}>Home</Button>;

    return (
      <>
        <Text fontSize="medium">{error.message || "Something went wrong!"}</Text>
        {button}
      </>
    );
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    return error ? (
      <Box p="medium" className={style.boundary}>
        <Stack
          gap="medium"
          style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}
        >
          {this.renderError()}
        </Stack>
      </Box>
    ) : (
        children
      );
  }
}

export default withRouter(ErrorBoundary);
